import * as actionTypes from './action-types'

export const fetchCountries = () => ({
  type: actionTypes.COUNTRIES,
})

export const initConfig = () => ({
  type: actionTypes.INIT_CONFIG,
})

export const setUserLocale = locale => ({
  type: actionTypes.SET_LOCALE,
  payload: { locale },
})

export const setIsConfigLoaded = isLoaded => ({
  type: actionTypes.SET_IS_CONFIG_LOADED,
  payload: isLoaded,
})
